import { render } from "./DefaultSvgNav.vue?vue&type=template&id=0afe4da0&scoped=true"
import script from "./DefaultSvgNav.vue?vue&type=script&lang=js"
export * from "./DefaultSvgNav.vue?vue&type=script&lang=js"

import "./DefaultSvgNav.vue?vue&type=style&index=0&id=0afe4da0&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afe4da0"]])

export default __exports__